"use client";

import { ComponentProps } from "react";
import {
  Root,
  Viewport,
  ScrollAreaScrollbar,
  Corner,
  ScrollAreaThumb,
} from "@radix-ui/react-scroll-area";
import { cn } from "@drpcrd/utils";

export const ScrollArea = ({
  className,
  children,
  ...props
}: ComponentProps<typeof Root>) => (
  <Root
    data-slot="scroll-area"
    className={cn("relative", className)}
    {...props}
  >
    <Viewport
      data-slot="scroll-area-viewport"
      className="focus-visible:ring-ring/50 size-full rounded-[inherit] outline-none transition-[color,box-shadow] focus-visible:outline-1 focus-visible:ring-[3px]"
    >
      {children}
    </Viewport>
    <ScrollBar />
    <Corner />
  </Root>
);

export const ScrollBar = ({
  className,
  orientation = "vertical",
  ...props
}: ComponentProps<typeof ScrollAreaScrollbar>) => (
  <ScrollAreaScrollbar
    data-slot="scroll-area-scrollbar"
    orientation={orientation}
    className={cn(
      "flex touch-none select-none p-px transition-colors",
      orientation === "vertical" &&
        "h-full w-2.5 border-l border-l-transparent",
      orientation === "horizontal" &&
        "h-2.5 flex-col border-t border-t-transparent",
      className,
    )}
    {...props}
  >
    <ScrollAreaThumb
      data-slot="scroll-area-thumb"
      className="bg-border relative flex-1 rounded-full"
    />
  </ScrollAreaScrollbar>
);
